import React from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import styles from "./Mensalidades.module.css";

const DetalhesModal = ({ isOpen, onClose, mensalidade }) => {
  if (!isOpen || !mensalidade) return null;

  // =========================
  // Helpers defensivos
  // =========================
  const numero = (v) => Number(v) || 0;
  const texto = (v) => (v === null || v === undefined || v === "" ? "—" : v);

  // =========================
  // Dados base
  // =========================
  const valorBase = numero(mensalidade.valor);
  const valorMulta = numero(mensalidade.multa);
  const valorTotal = numero(mensalidade.total);

  const estado = String(mensalidade.estado || "").toLowerCase();
  const estaPago = estado === "pago" || estado === "parcial";

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      {/* ========================= */}
      {/* Header */}
      {/* ========================= */}
      <div className={styles.modalHeader}>
        <h2>Detalhes da Mensalidade</h2>
        <button onClick={onClose} className={styles.closeBtn}>
          <FaTimes />
        </button>
      </div>

      {/* ========================= */}
      {/* Body */}
      {/* ========================= */}
      <div className={styles.modalBody}>
        <p>
          <strong>Aluno:</strong>{" "}
          {texto(mensalidade.aluno?.nome_completo)}
        </p>

        <p>
          <strong>Código:</strong>{" "}
          {texto(mensalidade.aluno?.codigo_aluno)}
        </p>

        <p>
          <strong>Classe / Turma:</strong>{" "}
          {texto(mensalidade.aluno?.classe)} /{" "}
          {texto(mensalidade.aluno?.turma)}
        </p>

        <p>
          <strong>Serviço:</strong> Mensalidade
        </p>

        <p>
          <strong>Mês/Ano:</strong>{" "}
          {texto(mensalidade.mesAno)}
        </p>

        <p>
          <strong>Referência:</strong>{" "}
          {texto(mensalidade.referencia)}
        </p>

        <hr />

        <p>
          <strong>Valor base:</strong>{" "}
          {valorBase.toFixed(2)} MZN
        </p>

        <p>
          <strong>Multa:</strong>{" "}
          {valorMulta.toFixed(2)} MZN
        </p>

        <p>
          <strong>Total:</strong>{" "}
          {valorTotal.toFixed(2)} MZN
        </p>

        <p>
          <strong>Estado:</strong>{" "}
          {texto(mensalidade.estado)}
        </p>

        {/* ========================= */}
        {/* Dados de pagamento */}
        {/* ========================= */}
        {estaPago && (
          <>
            <hr />

            <p>
              <strong>Forma de pagamento:</strong>{" "}
              {texto(mensalidade.forma_pagamento)}
            </p>

            <p>
              <strong>Data do pagamento:</strong>{" "}
              {mensalidade.detalhes?.data
                ? new Date(mensalidade.detalhes.data).toLocaleString("pt-PT")
                : "—"}
            </p>

            <p>
              <strong>Telefone:</strong>{" "}
              {texto(mensalidade.detalhes?.telefone)}
            </p>
          </>
        )}
      </div>

      {/* ========================= */}
      {/* Footer */}
      {/* ========================= */}
      <div className={styles.modalFooter}>
        <button className={styles.btn} onClick={onClose}>
          Fechar
        </button>
      </div>
    </Modal>
  );
};

export default DetalhesModal;
